module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }